import type * as SchemaTypes from '../types';

import type { TranslatedStringSpecsFragment } from './TranslatedStringSpecs';
import { gql } from '@apollo/client';
import { TranslatedStringSpecsFragmentDoc } from './TranslatedStringSpecs';
export type MenuItemSpecs_MenuCustomPathItem_Fragment = (
  { __typename: 'MenuCustomPathItem' }
  & Pick<SchemaTypes.MenuCustomPathItem, 'pathname' | 'id' | 'icon'>
  & { label: (
    { __typename: 'TranslatedString' }
    & TranslatedStringSpecsFragment
  ) }
);

export type MenuItemSpecs_MenuEndpointItem_Fragment = (
  { __typename: 'MenuEndpointItem' }
  & Pick<SchemaTypes.MenuEndpointItem, 'endpointId' | 'id' | 'icon'>
  & { endpoint: (
    { __typename: 'ApplicationListEndpoint' }
    & Pick<SchemaTypes.ApplicationListEndpoint, 'pathname'>
  ) | (
    { __typename: 'ConfiguratorApplicationEntrypoint' }
    & Pick<SchemaTypes.ConfiguratorApplicationEntrypoint, 'pathname'>
  ) | (
    { __typename: 'CustomerListEndpoint' }
    & Pick<SchemaTypes.CustomerListEndpoint, 'pathname'>
  ) | (
    { __typename: 'DummyPrivatePageEndpoint' }
    & Pick<SchemaTypes.DummyPrivatePageEndpoint, 'pathname'>
  ) | (
    { __typename: 'DummyWelcomePageEndpoint' }
    & Pick<SchemaTypes.DummyWelcomePageEndpoint, 'pathname'>
  ) | (
    { __typename: 'EventApplicationEntrypoint' }
    & Pick<SchemaTypes.EventApplicationEntrypoint, 'pathname'>
  ) | (
    { __typename: 'FinderApplicationEntrypoint' }
    & Pick<SchemaTypes.FinderApplicationEntrypoint, 'pathname'>
  ) | (
    { __typename: 'FinderApplicationPublicAccessEntrypoint' }
    & Pick<SchemaTypes.FinderApplicationPublicAccessEntrypoint, 'pathname'>
  ) | (
    { __typename: 'MobilityApplicationEntrypoint' }
    & Pick<SchemaTypes.MobilityApplicationEntrypoint, 'pathname'>
  ) | (
    { __typename: 'StandardApplicationEntrypoint' }
    & Pick<SchemaTypes.StandardApplicationEntrypoint, 'pathname'>
  ) | (
    { __typename: 'StandardApplicationPublicAccessEntrypoint' }
    & Pick<SchemaTypes.StandardApplicationPublicAccessEntrypoint, 'pathname'>
  ) | (
    { __typename: 'WebPageEndpoint' }
    & Pick<SchemaTypes.WebPageEndpoint, 'pathname'>
  ), label: (
    { __typename: 'TranslatedString' }
    & TranslatedStringSpecsFragment
  ) }
);

export type MenuItemSpecs_MenuLogoutActionItem_Fragment = (
  { __typename: 'MenuLogoutActionItem' }
  & Pick<SchemaTypes.MenuLogoutActionItem, 'id' | 'icon'>
  & { label: (
    { __typename: 'TranslatedString' }
    & TranslatedStringSpecsFragment
  ) }
);

export type MenuItemSpecsFragment = MenuItemSpecs_MenuCustomPathItem_Fragment | MenuItemSpecs_MenuEndpointItem_Fragment | MenuItemSpecs_MenuLogoutActionItem_Fragment;

export const MenuItemSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment MenuItemSpecs on MenuItem {
  id
  icon
  label {
    ...TranslatedStringSpecs
  }
  ... on MenuCustomPathItem {
    pathname
  }
  ... on MenuEndpointItem {
    endpointId
    endpoint {
      pathname
    }
  }
}
    `;